import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import SidebarPanel from './SidebarPanel';

class AccountSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOADING: true, 
            Notifications: false,
            Updated: false,
            userNAME: '',
            userIMAGE: '',
            userMOBILE: '',
            userEMAIL: '',
            userMOBILECODE: '',
            userMOBILENO: '',
            CUSTOMER_DET: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmAccount')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmAccount')[0].classList.add('was-validated');

        if(err==0)
        {
            $('#submitLoading').css('display','block');
            
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://m.donedelivery.in/api/accountupdate_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {
                
                //console.log(result);
                //alert(result);
                let updated = false;
                let notify = '';
                if(result.err!='' && result.err!=undefined)
                {
                    if(result.err=='1') notify = 'Name Field is Empty';
                    else if(result.err=='2') notify = 'Email Id Field is Empty';
                    else if(result.err=='3') notify = 'Mobile Area Code Field is Empty';
                    else if(result.err=='4') notify = 'Mobile No Field is Empty';
                    else if(result.err=='5') notify = 'Invalid Access Detected';
                    else if(result.err=='6') notify = 'A different user exists with the mobile area code and number entered';
                }
                else
                    updated = true;

                var userMOBILECODE = '+91';
                if(result.user_mobilecode!=='' && result.user_mobilecode!==undefined && result.user_mobilecode!=='undefined')
                    userMOBILECODE = result.user_mobilecode;

                that.setState({ Notifications: notify, Updated:updated, userNAME:result.user_name, userIMAGE:result.user_image, userMOBILE:result.user_mobile, userEMAIL:result.user_email, userMOBILECODE: userMOBILECODE, userMOBILENO:result.user_mobileno });
                $('#submitLoading').css('display','none');

                if(notify!='')
                    $('#ModalAlert').modal('show');
                if(updated)
                    $('#ModalUpdated').modal('show');
          });
        }
    }

    fetchCustomerProfile(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/profile_api.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);

            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            var userMOBILECODE = '+91';
            if(result.user_mobilecode!=='' && result.user_mobilecode!==undefined && result.user_mobilecode!=='undefined')
                userMOBILECODE = result.user_mobilecode;
                            
            that.setState({ LOADING:false, userNAME:result.user_name, userIMAGE:result.user_image, userMOBILE:result.user_mobile, userEMAIL:result.user_email, CUSTOMER_DET:CUSTOMER_DET, userMOBILECODE: userMOBILECODE, userMOBILENO:result.user_mobileno });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        var customer = localStorage.getItem('userData');
        this.fetchCustomerProfile('PROFILE',customer);
    }
    
    render() { 

        if(localStorage.getItem('userData')==null)
        {
	        return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/profile';
        let AppHeaderTitle = 'Edit Profile';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="login-form mt-1">
                        <div className="section pt-6">
                            <img src="/assets/img/done-image.png" alt="image" className="form-image imaged w140" />
                        </div>
                        <div className="section mt-5 mb-5 pr-3 pl-3">
                            <form id="frmAccount" encType="multipart/form-data" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                                <input type="hidden" value="UPDATE" className="form-control" name="mode" id="mode"  />
                                <input type="hidden" value={localStorage.getItem('userData')} className="form-control" name="customer" id="customer" />
                                <div className="form-group boxed mb-1">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtusername">Enter Your Name</label>
                                        <input type="text" className="square-inputbox form-control" name="txtusername" id="txtusername" required defaultValue={this.state.userNAME} />
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div>
                                        <div className="invalid-feedback">Please enter your name.</div>
                                    </div>
                                </div>
                                <div className="form-group boxed mb-1">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtuseremail">Enter Your Email Address</label>
                                        <input type="email" className="square-inputbox form-control" name="txtuseremail" id="txtuseremail" required pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" defaultValue={this.state.userEMAIL}/>
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                        <div className="valid-feedback">&nbsp;</div> 
                                        <div className="invalid-feedback">Please enter your email address.</div>
                                    </div>
                                </div>
                                <div className="form-group boxed mb-1">
                                    <div className="wid-20">
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="txtusercode">Code</label>
                                            <input type="text" className="square-inputbox form-control" name="txtusercode" id="txtusercode" required minLength="3" maxLength="6" autoComplete="off" defaultValue={this.state.userMOBILECODE}/>
                                            <i className="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                            <div className="valid-feedback">&nbsp;</div>
                                            <div className="invalid-feedback">Please enter your area code.</div>
                                        </div>
                                    </div>
                                    <div className="wid-80"> 
                                        <div className="input-wrapper">
                                            <label className="label" htmlFor="txtusermobile">Mobile No</label>
                                            <input type="text" className="square-inputbox form-control" name="txtusermobile" id="txtusermobile" required minLength="10" maxLength="11" pattern="[0-9]{10}" autoComplete="off" defaultValue={this.state.userMOBILENO}/>
                                            <i className="clear-input">
                                                <ion-icon name="close-circle"></ion-icon>
                                            </i>
                                            <div className="valid-feedback">&nbsp;</div>
                                            <div className="invalid-feedback">Please enter your 10 digit mobile no.</div>
                                        </div>
                                    </div>
                                    <div className="clear"></div>
                                </div>
                                {/*<div className="form-button-group pl-4 pr-4 bg-common">
                                    <button type="submit" className="lt-space1 text-upper btn btn-danger btn-block square btn-md">
                                    <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                        Save</button>
                                </div>*/}
                                <div className="form-button-group1 pr-2 pl-2">
                                    <div className="col-6">
                                        <div className="text-upper">
                                            <div className="row">
                                                <div className="col-12">
                                                    <button type="submit" className="btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-ssm btn-block">
                                                        <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                                        SAVE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="text-upper">
                                            <div className="row">
                                                <div className="col-12">
                                                    <Link to="/profile" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">Cancel</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-danger">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body"> 
                                            {this.state.Notifications} 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal fade dialogbox" id="ModalUpdated" data-backdrop="static" tabIndex="-1" role="dialog">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-icon text-success">
                                        <ion-icon name="checkmark-circle"></ion-icon>
                                    </div>
                                    <div className="modal-body"> 
                                        Account Details Updated Successfully 
                                    </div>
                                    <div className="modal-footer">
                                        <div className="btn-inline"> 
                                            <button type="button" className="btn" data-dismiss="modal">Ok</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default AccountSettings;


// WEBPACK FOOTER //
// ./src/components/AccountSettings.js